import GlobalBreadcrumbsMixin from '../../Mixins/GlobalBreadcrumbsMixin';
import ComponentMixin from '../../Mixins/ComponentMixin';
import CompanyStore from '../Company/CompanyStore';

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  async mounted () {
    this.setBreadcrumb(
      this.$t("common.teammates"),
      { name: 'All Empowerments', params: { companyId: CompanyStore.currentCompany.id } }
    );
  },

  methods: {
    navigateToIndexRoute (object) {
      this.$router.push({
        name: 'All Empowerments',
        params: {
          companyId: CompanyStore.currentCompany.id
        }
      });
    }
  }
};
